import './Sentry';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { Translation } from 'react-i18next';

import reportWebVitals from './reportWebVitals';

import FetchInterceptor from 'FetchInterceptor';
import App from 'App';
import store from 'redux/store';
import Auth0ProviderWithHistory from 'auth/Auth0ProviderWithHistory';
import { Modal } from 'antd';
import { addEventListener } from 'history/DOMUtils';

ReactDOM.render(
	// <React.StrictMode> // disabled due to https://github.com/ant-design/ant-design/issues/26136
	<BrowserRouter>
		<Provider store={store}>
			<Auth0ProviderWithHistory>
				<FetchInterceptor />
				<App />
			</Auth0ProviderWithHistory>
		</Provider>
	</BrowserRouter>,
	// </React.StrictMode>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
